import { Slide } from "@jelly/lesson";
import first from "./components/first";
import second from "./components/second";
import third from "./components/third";
import fourth from "./components/fourth";
import fifth from "./components/fifth";
import sixth from "./components/sixth";

const principle: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "0:0": 2,
      },
      colsSize: [1, 3],
      rowsSize: [1, 9],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Room acoustics measurement and simulation of an existing space\n",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    `Now the room impulse responses are generated using a simulation software instead of the room measurement procedure. The simulation software is based on Geometrical Acoustics and requires the room geometry, absorption and scattering coefficients and the positions of the sound source and the receiver as input data.` +
                    `<br />` +
                    `<br />` +
                    `Note that the created room geometry does not contain all details of the real environment, e.g, the audience area is just a flat surface, no details of the chairs are modelled. The actual acoustical behaviour is described by the absorption and scattering coefficient of this surface.` +
                    `<br />` +
                    `<br />` +
                    `The simulations are conducted for three datasets with different absorption coefficients and the reverberation time and clarity parametes are evaluated for the same four source-receiver combinations as for the measurements. Additionally, binaural auralizations are created for source position S3 to receiver R1.` +
                    `<br />` +
                    `<br />` +
                    `<b>Three sets of absorption data:</b>` +
                    `<ol><li style="font-size: 12px; color: #99A8C6; line-height: 16px">Initial set: Absorption coefficients based on databases in literaturee</li><li style="font-size: 12px; color: #FF6040; line-height: 16px">Matched data: Initial data adjusted so that measured and simulated reverberation time matches</li><li style="font-size: 12px; color: #2EB6EA; line-height: 16px">Matched data, but for occupied state: The seating area has now very high absorption of a dense audience instead of empty chairs</li></ol>`,
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: true,
                },
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "carousel",
              options: {
                controlsPosition: "bottom",
                components: [first, second, third, fourth, fifth, sixth],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
